import { combineReducers } from "redux";
import Linq8acmState from "./";
import batteriesReducer from "../batteries/state/reducer";
import powerSuppliesReducer from "../powerSupplies/state/reducer";
import outputsReducer from "../outputs/state/reducer";
import flagsReducer from "../flags/state/reducer";
import inputsReducer from "../inputs/state/reducer";
import timersReducer from "../timers/state/reducer";

export default combineReducers<Linq8acmState>({
  powerSupplies: powerSuppliesReducer,
  batteries: batteriesReducer,
  outputs: outputsReducer,
  flags: flagsReducer,
  inputs: inputsReducer,
  timers: timersReducer
});
